import { NavLink } from "react-router-dom";

const DesktopNavbarList = ({ nav }) => {
  return (
    nav.map((item, index) => (
      <li key={index} className="header-desktop-menu">
        <NavLink
          className="nav-menu" // TODO :::: text should be 16px
          to={item.link}
          activeClassName="active"
        >
          {item.title}
        </NavLink>
      </li>
    ))
  )
}

export default DesktopNavbarList;